<template>

  <div>

    <section class="outer-pad">

      <p>Any additional email addresses that are setup to receive Alerts will be listed here.</p>

      <Table 
        :headings="tableHeadings" 
        :items="table.items" 
        :loading="table.loading" 
        :loadingText="loadingText"
        :emptyLabel="emptyLabel"
        @resendEmailConfirmation="resendEmailConfirmation"
      />

    </section>

  </div>

</template>

<script>
import ApiService from './../../services/api.service'
import { mapMutations } from 'vuex'
import Table from './../../components/Table.vue'
import TableButton from './../../components/Display/TableButton.vue'
export default {
  name: "EmailAddresses",
  components: {
    Table
  },
  data() {
    return {
      table: {
        loading: true,
        items: []
      }
    }
  },
  methods: {
    ...mapMutations('general',['updateLoadingText']),
    loadEmailAddresses () {

      this.table.loading = true;

      ApiService.get( 'alerts/email-addresses' )
      .then( function( info ) {

        this.table.items = info.data;

        this.table.loading = false;

      }.bind(this))
      .catch( function(err) {

      }.bind(this));

    },
    resendEmailConfirmation ({ _id }) {

      this.updateLoadingText('Resending email...')

      ApiService.post( 'alerts/email-addresses/resend', { _id: _id } )
      .then( function( info ) {

        this.updateLoadingText();
        this.$snotify.success('Ther email has been sent.','Confirm Email');

      }.bind(this))
      .catch( function(err) {

      }.bind(this));
    }
  },
  computed: {

    emptyLabel () {

      return 'There are no Email Addresses at the moment';

    },

    loadingText () {

      return 'Loading Email Addresses...';

    },

    tableHeadings() {
      return {
        email: { value: 'Email' },
        created: { value: 'Created', dateFormat: 'jS M Y' },
        confirmedBtn: { value: 'Confirmed', component: TableButton, event: 'resendEmailConfirmation' }
      }
    }

  },
  created () {

    this.loadEmailAddresses ();

  }
};
</script>
<style lang="less" scoped>
.project-dropdown-wrap {

  margin: 25px 10px;
    position: relative;
    height: 36px;

  .project-dropdown-wrap-inner {

    width: 100%;
    position: absolute;
    background-color: #fff;

    .v-select {
      .vs__clear {
        display: none;
      }
    }

  }
}
@media screen and (min-width: 768px) {
  .project-dropdown-wrap {
    position: absolute;
    width: 250px;
    right: 0px;
    top: 47px;
    z-index: 3;
    .project-dropdown-wrap-inner {
      max-width: 300px;
        right: 0;
    }
  }
}
@media screen and (min-width: 1024px) {
  .project-dropdown-wrap {
    right: 14px;
    top: 61px;
  }
}
</style>